module.exports = __webpack_public_path__ + "img/096_L.7e2e9113.png";